import { render, staticRenderFns } from "./LlegendaIndicadorPositiu.vue?vue&type=template&id=43111d92&scoped=true&"
import script from "./LlegendaIndicadorPositiu.vue?vue&type=script&lang=js&"
export * from "./LlegendaIndicadorPositiu.vue?vue&type=script&lang=js&"
import style0 from "./LlegendaIndicadorPositiu.vue?vue&type=style&index=0&id=43111d92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43111d92",
  null
  
)

export default component.exports